


/**
* Participant Statuses within GuideStream
*/
export enum ParticipantStatus{
    /**
    * Waiting
    */
    Waiting = 0,
    /**
    * Active
    */
    Active = 1,
    /**
    * Departed
    */
    Departed = 2,
    /**
    * Denied access
    */
    Denied = 3,
    /**
    * Removed from session
    */
    Removed = 4
}

